import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';

import Homepage from './Homepage';
import GameChat from './gameChat/GameChat';
import VoiceComplete from './gameChat/VoiceComplete';
import VoiceNotHeard from './gameChat/VoiceNotHeard';
import AdminDashboard from './adminDashboard/AdminDashboard';
import InsightsArticles from './insights/InsightsArticles';
import Canvasses from './canvasses/Canvasses';
import Canvass from './canvasses/Canvass';
import CanvassInterviews from './interviews/CanvassInterviews';
import NewCanvass from './canvasses/NewCanvass';
import { Button } from './layout/buttons/Button';
import { PageHeader } from './layout';
import Profile from './profile/Profile';
import NewUserTutorial from './tutorial/NewUserTutorial';
import AnalyticsDashboard from '../analytics/AnalyticsDashboard';
import DataPrivacy from './dataprivacy/DataPrivacy';

function RequireAuth({ children }) {
    const { instance } = useMsal();
    const account = useAccount(instance.getActiveAccount());
    // useEffect(() => {

    //     const syncClient = async () => {
    //         try {
    //             const oid = instance.getActiveAccount()?.idTokenClaims?.oid || account?.localAccountId;
    //             if (!oid) return;
    //             const email = account?.username || '';
    //             const orgFromEmail = email.includes('@') ? email.split('@')[1] : undefined;

    //             const accessToken = await getAccessToken({ instance, account, scopes: ['User.Read'] });
    //             const baseSelect = 'displayName,jobTitle,companyName,department,streetAddress,city,state,postalCode,country,userPrincipalName,id,mail,customSecurityAttributes';
    //             const data = await fetchGraphMe({ accessToken, select: baseSelect });

    //             let client = getClient();
    //             if (!client || client.early) {
    //                 client = await fetchClientById({ clientId: oid }).catch(() => null);
    //             }
    //             if (client) {
    //                 client.userViewRole = data.customSecurityAttributes?.userViewRole || {};
    //                 setClient(client);
    //                 return;
    //             }
    //             const created = await createClient({
    //                 clientId: oid,
    //                 body: { clientId: oid, ...(orgFromEmail ? { organization: orgFromEmail } : {}) }
    //             });
    //             created.userViewRole = data?.customSecurityAttributes?.userViewRole || {};
    //             setClient(created);
    //             setIsTutorialComp(Boolean(created?.isTutorialComp));
    //             setIsFirstCanvassCreated(Boolean(created?.isFirstCanvassCreated));
    //         } catch {}
    //     };
    //     if (account) {
    //         syncClient();
    //     }
    // }, [account, instance]);
    return account ? children : <Homepage />;
}

function RequireAdmin({ children }) {
    const { instance } = useMsal();
    const account = useAccount(instance.getActiveAccount());
    if (!account) return <Homepage />;
    const isAdmin = Boolean(account?.idTokenClaims?.roles?.includes('staging_administrator') || account?.idTokenClaims?.roles?.includes('production_administrator'));
    return isAdmin ? children : <Homepage />;
}

const AppRoutes = () => {
    const navigate = useNavigate();
    return (
        <Routes>
            {/* Public route: interview/chat interface is accessible without login */}
            <Route 
                path="/interview/:id" 
                element={<GameChat />} 
            />

            {/* Authenticated routes */}
            <Route
                path="/"
                element={<Homepage />}
            />

            {/* <Route 
                path="/dashboard" 
                element={<RequireAuth><Dashboard /></RequireAuth>} 
            /> */}

            {/* <Route 
                path="/research" 
                element={<RequireAuth><ChatBot /></RequireAuth>} 
            /> */}

            <Route 
                path="/admin" 
                element={<RequireAuth><RequireAdmin><AdminDashboard /></RequireAdmin></RequireAuth>} 
            />

            <Route 
                path="/insights" 
                element={<RequireAuth><InsightsArticles /></RequireAuth>} 
            />

            <Route
                path="/profile"
                element={<RequireAuth><Profile /></RequireAuth>}
            />

            <Route
                path="/analytics"
                element={<RequireAuth><AnalyticsDashboard /></RequireAuth>}
            />

            {/* <Route 
                path="/game/:id" 
                element={<RequireAuth><GameComponent /></RequireAuth>} 
            /> */}

            <Route 
                path="/canvasses" 
                element={<RequireAuth><Canvasses /></RequireAuth>} 
            />

            <Route 
                path="/welcome" 
                element={<RequireAuth><NewUserTutorial /></RequireAuth>} 
            />

            <Route
                path="/canvasses/:canvassId/interviews"
                element={<RequireAuth><RequireAdmin><CanvassInterviews /></RequireAdmin></RequireAuth>}
            />

            {/* <Route 
                path="/test/beep"
                element={<RequireAuth><BeepTestPage /></RequireAuth>}
            /> */}
            <Route 
                path="/canvass/new" 
                element={<RequireAuth><NewCanvass /></RequireAuth>} 
            />
            <Route 
                path="/canvass/:canvassId" 
                element={<RequireAuth><Canvass /></RequireAuth>} 
            />
            <Route
                path="/canvasses/:canvassId/interviews"
                element={<RequireAuth><RequireAdmin><CanvassInterviews /></RequireAdmin></RequireAuth>}
            />
            <Route
                path="/voice/complete"
                element={<VoiceComplete/>}
            />
            <Route
                path="/voice/completed"
                element={<VoiceNotHeard/>}
            />
            <Route
                path="/data-privacy"
                element={<DataPrivacy/>}
            />

            {/* 404 route remains available; content will show regardless of auth */}
            <Route 
                path="*" 
                element={
                    <div className="not-found">
                        <PageHeader title="Page Not Found" align="center" subtext="The page you're looking for doesn't exist." size="lg"/>
                        <Button variant="primary" onClick={() => navigate("/")}>Return to Dashboard</Button>
                    </div>
                } 
            />
        </Routes>
    );
};

export default AppRoutes;
